import { t } from '../app-utils/translations';

export const isDesignPage = (): { isDesignpage: boolean; pageName: string } => {
  const path = window.location.pathname;
  if (path.includes(t('my-account-projects')) || path.includes(t('my-account-uploads'))) {
    return { isDesignpage: false, pageName: '' };
  }
  if (path.includes(t('design')) || path.includes('/design')) {
    return { isDesignpage: true, pageName: 'Design' };
  }

  return { isDesignpage: false, pageName: '' };
};
export const updateDesignButtonState = (innerText: string, disableButton: boolean) => {
  const buttonName = 'onlineBtn';
  const startButton = document.getElementById(buttonName) as HTMLButtonElement;
  const loader = document.getElementById('loader') as HTMLButtonElement;
  if (startButton) {
    // eslint-disable-next-line no-console
    console.log('changing button state', startButton, innerText);
    if (innerText && startButton.childNodes && startButton.childNodes.length) {
      if (startButton.childNodes.length > 1) {
        startButton.childNodes[1].nodeValue = innerText;
      } else startButton.innerText = innerText;
    }
    startButton.disabled = disableButton;
  }
  if (loader) loader.style.display = 'none';
};
export const hideDesignHelpButton = () => {
  if (isDesignPage()) {
    console.info('hiding Design button');
    const buttonName = 'onlineBtn';
    const startButton = document.getElementById(buttonName) as HTMLButtonElement;
    if (startButton) {
      startButton.style.display = 'none';
      startButton.disabled = true;
    }
  }
};
